<template>
  <div>
    <Row :gutter="5" class="m-b-5">
      <i-col :xs="24" :sm="12" :md="6" class="m-b-5">
        <DatePicker size="small"  placeholder="结算单的开始时间" v-model="statementInvoiceQuery.startDate" @on-change="statementInvoiceQuery.startDate=$event" style="width:100%"></DatePicker>
      </i-col>
      <i-col :xs="24" :sm="12" :md="6" class="m-b-5">
        <DatePicker size="small"  placeholder="结算单的结束时间" v-model="statementInvoiceQuery.endDate" @on-change="statementInvoiceQuery.endDate=$event" style="width:100%"></DatePicker>
      </i-col>
       <i-col  v-if="isAuth('StatementInvoice_Manage_View')" :xs="24" :sm="12" :md="6" class="m-b-5">
          <Select size="small" v-model="statementInvoiceQuery.companyId" placeholder="所属公司" clearable @on-change="companyChange">
            <Option v-for="(channel,index) in channellist" :key="index" :value="channel.id">{{channel.name}}</Option>
          </Select>
      </i-col>
      <i-col v-if="isAuth('StatementInvoice_Manage_View')"  :xs="24" :sm="12" :md="6" class="m-b-5">
          <Select size="small" v-model="statementInvoiceQuery.userId" placeholder="归属销售" clearable>
            <Option v-for="user in channelUsers" :key="user.id" :value="user.id">{{ user.name}}</Option>
          </Select>
      </i-col>
      <i-col :xs="24" :sm="12" :md="6" class="m-b-5">
        <i-select size="small"  placeholder="状态" v-model="statementInvoiceQuery.invoiceProgress"  >
            <i-option :value="0">未开票</i-option>
            <i-option :value="1">部分开票</i-option>
            <i-option :value="2">完全开票</i-option>
        </i-select>
      </i-col>
      <i-col :xs="24" :sm="12" :md="6" class="m-b-5">
        <i-input  size="small" placeholder="关键字：支持名称查询" v-model="statementInvoiceQuery.keyword"></i-input>
      </i-col>
      <i-col :xs="24" :sm="12" :md="6" class="m-b-5">
        <i-button size="small"  type="primary" icon="ios-search" @click="handleSearch">搜索</i-button>
      </i-col>
    </Row>

    <i-table :data="list" :columns="titles" stripe></i-table>
    <div class="paging_style">
        <Page size="small" show-total show-elevator  :page-size="statementInvoiceQuery.pageSize" :total="total" @on-change="handlePageChanged"></Page>
    </div>
  </div>
</template>

<script>
import { getBusinessPage } from '@/api/scp/invoice'

import { toMoney } from '@/utils/wnumb_own'
import { GetCurrentSchedule } from '@/utils/dateFormat.js'
import { formatInvoiceStatus } from '@/utils/tagStatus'
import { getProjectCompany } from '@/api/os/project'
import { getSellerPage } from '@/api/os/companyuser'

export default {
  data () {
    return {
      channellist: [],
      departments: [],
      channelUsers: [],
      list: [],
      total: 0,
      titles: [
        { title: '编码', key: 'code' },
        { title: '名称', key: 'name' },
        { title: '客户', key: 'advertiserName' },
        {
          title: '档期',
          render: (h, data) => {
            if (data.row.startDate) {
              return h('div', [
                h('span', GetCurrentSchedule(data.row.startDate, data.row.endDate))
                // h('span', { style: { color: '#ee7c4b' } }, '(' + GetPublishDay(data.row.startDate, data.row.endDate) + ')')
              ])
            } else {
              return h('span', '--')
            }
          }
        },
        {
          title: '结算单金额',
          align: 'right',
          render: (h, data) => {
            return h('span', {
              attrs: {
                style: 'color:#44bd32'
              }
            }, toMoney(data.row.amount))
          }
        },
        {
          title: '已开票金额(含税)',
          align: 'right',
          render: (h, data) => {
            return h('span', {
              attrs: {
                style: 'color:#44bd32'
              }
            }, toMoney(data.row.invoicedAmount))
          }
        },
        {
          title: '状态',
          align: 'center',
          render: (h, data) => {
            let status = 0
            let statusName = ''
            if (data.row.invoicedAmount === 0 && data.row.amount > 0) {
              status = 0
              statusName = '未开票'
            } else if (data.row.invoicedAmount < data.row.amount) {
              status = 1
              statusName = '部分开票'
            } else {
              status = 2
              statusName = '完全开票'
            }

            return formatInvoiceStatus(h, status, statusName)
          }
        },
        { title: '备注', key: 'mark' },
        {
          title: '操作',
          render: (h, data) => {
            return h('div', [
              h('a', {
                on: {
                  click: () => {
                    this.handleShowDetail(data.row.id)
                  }
                }
              }, '查看详情')
            ])
          }
        }
      ]

    }
  },
  methods: {
    initPage () {
      this.channellist = []
      getProjectCompany({ projectId: this.$store.getters.token.userInfo.currentProjectId, type: 3 }).then(res => {
        this.channellist = res
        if (!this.statementInvoiceQuery.companyId) {
          if (this.channellist.length > 1 && this.isAuth('StatementInvoice_Manage_View')) {
            this.statementInvoiceQuery.companyId = null
          } else {
            this.statementInvoiceQuery.companyId = this.$store.getters.token.userInfo.companyId
          }
        }
        this.getChannelUserList()
      })
    },
    companyChange () {
      this.statementInvoiceQuery.userId = ''
      this.getChannelUserList()
    },

    getChannelUserList () {
      this.channelUsers = []
      const data = {
        companyId: this.statementInvoiceQuery.companyId,
        pageNumber: 1,
        pageSize: 1000
      }
      if (data.companyId) {
        getSellerPage(data).then(response => {
          this.channelUsers = response.list
        })
      } else {
        this.statementInvoiceQuery.userId = ''
      }
      this.getData()
    },
    getData () {
      // this.statementInvoiceQuery.userId = this.$store.getters.token.userInfo.userId
      this.statementInvoiceQuery.invoiceProgressList = JSON.stringify([this.statementInvoiceQuery.invoiceProgress])

      this.$store.commit('set_query_statementInvoiceQuery', this.statementInvoiceQuery)
      getBusinessPage(this.statementInvoiceQuery).then(res => {
        this.total = res.totalRow
        this.list = res.list
      })
    },
    handleShowDetail (invoiceId) {
      this.$emit('on-detail', invoiceId)
    },
    handleSearch () {
      this.statementInvoiceQuery.pageNumber = 1
      this.getData()
    },
    handlePageChanged (page) {
      this.statementInvoiceQuery.pageNumber = page
      this.getData()
    }
  },
  created () {
    this.statementInvoiceQuery.userId = this.isAuth('StatementInvoice_Manage_View') ? this.statementInvoiceQuery.userId : this.$store.getters.token.userInfo.userId
    this.initPage()
  },
  computed: {
    statementInvoiceQuery () {
      return this.$store.state.contractQuery.statementInvoiceQuery
    }
  }

}
</script>
